<template>
    <div class="grid-content-row"><slot></slot></div>
</template>

<style lang="sass" scoped>
$grey-color: #efefef
$border-color: darken($grey-color, 7%)

.grid-content-row
    border-top: 1px solid $border-color
    padding: 10px 20px
    &:first-child
        border: none
</style>


<script>
export default { }
</script>
